import { Routes } from '@angular/router';
import { NewPatientFormComponent } from './registration/new-patient-form/new-patient-form.component';
import { ConsentFormComponent } from './registration/consent-form/consent-form.component';
import { AuthGuard } from './auth.guard';
import { LoginComponent } from './login/login.component';
import { PatientDashboardComponent } from './registration/patient-dashboard/patient-dashboard.component';
import { DocumentsComponent } from './documents/documents.component';
import { NotificationsComponent } from './registration/notifications/notifications.component';
import { PatientDashboardMainComponent } from './registration/patient-dashboard-main/patient-dashboard-main.component';
import { ProfileTabsComponent } from './registration/profile-tabs/profile-tabs.component';
import { FormSelectorComponent } from './registration/form-selector/form-selector.component';
import { AddressAutoCompleteComponent } from './registration/address-auto-complete/address-auto-complete.component';
import { AppointmentSchedulerComponent } from './registration/appointment-scheduler/appointment-scheduler.component';
import { NewPatientComponent } from './registration/new-patient/new-patient.component';
import { AuthComponent } from './auth/auth.component';
import { NewPatientSchedulerComponent } from './new-patient-scheduler/new-patient-scheduler.component';
import { UnsubscribeComponent } from './unsubscribe/unsubscribe.component';
import { DeeplinkHandlerComponent } from './registration/deeplink-handler/deeplink-handler.component';
import { PatientReviewComponent } from './patient-review/patient-review.component';
import { PaymentCenterComponent } from './registration/payment-center/payment-center.component';
import { AccountHistoryComponent } from './registration/account-history/account-history.component';
import { PatientsListComponent } from './patients-list/patients-list.component';
import { InsuranceManagementComponent } from './registration/insurance-management/insurance-management.component';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'handle-deeplink', component: DeeplinkHandlerComponent },
  { path: 'clinic-review', component: PatientReviewComponent},
  { path: 'auth', component: AuthComponent },
  { path: 'login', component: LoginComponent },
  { path: 'signup', loadComponent: () => import('./signup/signup.component').then(m => m.SignupComponent) },
  { path: 'unsubscribe', component: UnsubscribeComponent },
  { path: 'privacy', loadComponent: () => import('./legal/privacy-policy/privacy-policy.component').then(m => m.PrivacyPolicyComponent) },
  { path: 'terms', loadComponent: () => import('./legal/terms-of-service/terms-of-service.component').then(m => m.TermsOfServiceComponent) },
  { path: 'new-patient', component: NewPatientComponent },
  { path: 'new-patient-schedule', component: NewPatientSchedulerComponent },
  // Kiosk Mode routes (lazy-loaded)
  {
    path: 'kiosk',
    loadChildren: () => import('./kiosk/kiosk.routes').then(m => m.kioskRoutes)
  },

  { path: 'appointment/:appointmentId', component: AppointmentSchedulerComponent, canActivate: [AuthGuard]},
  { path: 'dashboard', component: PatientDashboardComponent, canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'main', pathMatch: 'full' },
      { path: 'patients-list', component: PatientsListComponent, canActivate: [AuthGuard] },
      { path: 'main', component: PatientDashboardMainComponent },
      { path: 'notifications', component: NotificationsComponent },
      { path: 'documents', component: DocumentsComponent },
      { path: 'profile-manage', component: ProfileTabsComponent, canActivate: [AuthGuard] },
      { path: 'forms/:templateId', component: NewPatientFormComponent, canActivate: [AuthGuard] },
      { path: 'consent/:templateId', component: ConsentFormComponent, canActivate: [AuthGuard] },
      { path: 'all-forms', component: FormSelectorComponent, canActivate: [AuthGuard] },
      { path: 'account-history', component: AccountHistoryComponent, canActivate: [AuthGuard] },
      { path: 'address', component: AddressAutoCompleteComponent, canActivate: [AuthGuard] },
      { path: 'appointment/:appointmentId', component: AppointmentSchedulerComponent, canActivate: [AuthGuard]},
      { path: 'payments', component: PaymentCenterComponent, canActivate: [AuthGuard]},
      { path: 'insurance/manage', component: InsuranceManagementComponent, canActivate: [AuthGuard]},
    ],
  },
  { path: '**', redirectTo: 'login' }
];